import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import {HttpClient} from '@angular/common/http';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Router} from '@angular/router';
import * as HashIds from 'hashids';
import * as Hash from 'hash.js';

@Injectable()
export class AuthenticationService {
  constructor(public JwtHelper: JwtHelperService, private http: HttpClient, private router: Router) {
    //
  }

  resetPassword(email: string, token: string, password: string): Observable<boolean> {
    const body = {
      data: {
        type: 'Passwords',
        attributes: {
          email: email,
          password: password,
          token: token
        }
      }
    };

    return this.http.post('/passwords', body).map((response: any) => {
      return !!response;
    });
  }

  forgotPassword(email: string) {
    const body = {
      data: {
        type: 'PasswordResets',
        attributes: {
          email: email
        }
      }
    };

    return this.http.post('/passwords/resets', body);
  }

  logIn(username: string, password: string): Observable<boolean> {
    const body = {
      data: {
        type: 'AccessTokens',
        attributes: {
          email: username,
          password: password
        }
      }
    };

    return this.http.post('/access-tokens', body).map((response: any) => {
      return this.saveToken(response);
    });
  }

  refreshToken() {
    return this.http.post('/access-tokens/refresh', null, {
      headers: {
        'content-type': 'application/json',
        authorization: `Bearer ${this.getToken()}`
      }
    });
  }

  logOut(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('token');
    localStorage.removeItem('timestamp');
    if (localStorage.getItem('isPro')) localStorage.removeItem('isPro');
    if (localStorage.getItem('isPremium')) localStorage.removeItem('isPremium');

    this.router.navigate(['/login']);
  }

  public getToken(): string {
    return localStorage.getItem('accessToken');
  }

  saveToken(response: any): boolean {
    const token = response && response.data && response.data.attributes && response.data.attributes.access_token;

    if (token) {
      const decodedToken = this.JwtHelper.decodeToken(token);
      
      // store username and jwt token in local storage to keep user logged in between page refreshes
      localStorage.setItem('accessToken', token);
      localStorage.setItem('userId', decodedToken.id);
      localStorage.setItem('userRole', decodedToken.role);
      localStorage.setItem('token', decodedToken.token);
      localStorage.setItem('timestamp', decodedToken.timestamp);
      localStorage.setItem('revision', decodedToken.revision);
      if (decodedToken.isPro) localStorage.setItem('isPro', '1');
      if (decodedToken.isPremium) localStorage.setItem('isPremium', '1');

      // return true to indicate successful login
      return true;
    } else {
      // return false to indicate failed login
      return false;
    }
  }

  public isAuthenticated(): boolean {
    return (null !== this.getToken());
  }

  public userId(): string {
    return localStorage.getItem('userId');
  }


  public userRole(): string {
    return localStorage.getItem('userRole');
  }

  private token(): string {
    return localStorage.getItem('token');
  }

  private revision(): string {
    return localStorage.getItem('revision');
  }

  private timestamp(): string {
    return localStorage.getItem('timestamp');
  }

  public isPro(): boolean {
    return localStorage.getItem('isPro') === '1';
  }

  public isPremium(): boolean {
    return localStorage.getItem('isPremium') === '1';
  }

  private getHash(): string {
    const a = new HashIds('' + this.timestamp() + this.userRole() + this.userId());
    const b = '' + a.encode(parseInt(this.userId(), 10));

    return ('' + Hash.sha256().update(b).digest('hex')).toLowerCase();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/authentication.service.ts